// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608271604/js/" + chunkId + "." + {"44":"128b878c","225":"23026a91","481":"e8503197","486":"5c949468","770":"97a10e8b"}[chunkId] + ".0.805474817238273.chunk.js";
};